module.exports = __webpack_public_path__ + "img/abr_cn.007077b.jpg";